/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IHandleRaceLoot,
  IHandleRaceLootInterface,
} from "../IHandleRaceLoot";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "from",
            type: "address[]",
          },
          {
            internalType: "address[]",
            name: "to",
            type: "address[]",
          },
          {
            internalType: "address[]",
            name: "currency",
            type: "address[]",
          },
          {
            internalType: "uint256[][]",
            name: "ids",
            type: "uint256[][]",
          },
          {
            internalType: "uint256[][]",
            name: "amounts",
            type: "uint256[][]",
          },
          {
            internalType: "enum Payment.PaymentTypes[]",
            name: "paymentType",
            type: "uint8[]",
          },
        ],
        internalType: "struct Payment.Struct",
        name: "payment",
        type: "tuple",
      },
    ],
    name: "handleRaceLoot",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
];

export class IHandleRaceLoot__factory {
  static readonly abi = _abi;
  static createInterface(): IHandleRaceLootInterface {
    return new utils.Interface(_abi) as IHandleRaceLootInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IHandleRaceLoot {
    return new Contract(address, _abi, signerOrProvider) as IHandleRaceLoot;
  }
}
